import React, { useState, useEffect } from "react";
import { db, } from "../../services/firebaseConfig";
import { collection, onSnapshot, updateDoc, doc, getDoc, query, where, addDoc, getDocs, deleteDoc } from "firebase/firestore";
import { generateRefNumber } from "../../utils/referenceNumber";
import { ORDER_STATUS } from "../../utils/orderStatus";

import { jsPDF } from "jspdf";

import "../../styles/OrderList.css";

const OrderList = ({ onPendingChange }) => {
    const [orders, setOrders] = useState([]);

    const storedUser = JSON.parse(localStorage.getItem("user"));
    const [selectedOrders, setSelectedOrders] = useState([]);

    useEffect(() => {
        if (typeof onPendingChange === "function") {
            onPendingChange(selectedOrders.length > 0);
        }
    }, [selectedOrders, onPendingChange]);

    useEffect(() => {
        const handler = (e) => {
            if (selectedOrders.length > 0) {
                e.preventDefault();
                e.returnValue = "";
            }
        };
        window.addEventListener("beforeunload", handler);
        return () => window.removeEventListener("beforeunload", handler);
    }, [selectedOrders]);



    const userId = storedUser?.id;
    const userRole = storedUser?.role || "";
    const userDistrict = storedUser?.district || "";
    const [extraQuantities, setExtraQuantities] = useState({});

    // ✅ Accordion (open row)
    const [openRowId, setOpenRowId] = useState(null);

    const toggleRow = (orderId) => {
        setOpenRowId((prev) => (prev === orderId ? null : orderId));
    };

    // ✅ kira summary ringkas untuk paparan awal
    const getOrderItemsSummary = (order) => {
        const items = Array.isArray(order?.items) ? order.items : [];
        let products = items.length;

        // jumlah unit (qty) cuba baca dari semua jenis struktur
        let totalUnits = 0;

        items.forEach((item) => {
            // hargaSnapshot non-split
            if (item?.hargaSnapshot && typeof item.hargaSnapshot.qty === "number") {
                totalUnits += Number(item.hargaSnapshot.qty || 0);
                return;
            }

            // hargaSnapshot split (tiada qty number)
            if (item?.hargaSnapshot && typeof item.hargaSnapshot === "object" && typeof item.hargaSnapshot.qty !== "number") {
                Object.values(item.hargaSnapshot).forEach((v) => {
                    totalUnits += Number(v?.qty || 0);
                });
                return;
            }


            // struktur lama
            if (typeof item?.quantity === "number") totalUnits += Number(item.quantity || 0);
            else if (item?.sizes && typeof item.sizes === "object") {
                Object.values(item.sizes).forEach((q) => (totalUnits += Number(q || 0)));
            } else if (item?.years && typeof item.years === "object") {
                Object.values(item.years).forEach((q) => (totalUnits += Number(q || 0)));
            }
        });

        return { products, totalUnits };
    };


    useEffect(() => {
        if (!userId) return;

        let q;
        if (userRole === "pengerusi") {
            q = query(collection(db, "inventori", "selangor", "orders"),
                where("district", "==", userDistrict));
        } else {
            q = query(collection(db, "inventori", "selangor", "orders"),
                where("userId", "==", userId));
        }

        const unsubscribe = onSnapshot(q, async (snapshot) => {
            const ordersList = await Promise.all(snapshot.docs.map(async (docSnap) => {
                const orderData = docSnap.data();

                if (!orderData.branchName && orderData.userId) {
                    const userRef = doc(db, "inventori", "selangor", "users", orderData.userId);
                    const userSnap = await getDoc(userRef);
                    if (userSnap.exists()) {
                        orderData.branchName = userSnap.data().branchName || "Tidak Diketahui";
                    } else {
                        orderData.branchName = "Tidak Diketahui";
                    }
                }

                return { id: docSnap.id, ...orderData };
            }));

            setOrders(ordersList);
        });

        return () => unsubscribe();
    }, [userId, userRole, userDistrict]);



    const downloadInvoice = async (order) => {
        const docPDF = new jsPDF();


        const logo = new window.Image();
        logo.src = "/logo_pasti.png";
        logo.onload = () => {
            docPDF.addImage(logo, "PNG", 10, 10, 30, 30);
            docPDF.setFontSize(14);
            docPDF.text("INVOIS PENGHANTARAN", 50, 20);

            docPDF.setFontSize(10);
            docPDF.text("Daripada:", 10, 45);
            docPDF.text("Pengarah PASTI Selangor", 30, 45);

            docPDF.text("Kepada:", 10, 52);
            docPDF.text(`${order.branchName || "-"}`, 30, 52);

            docPDF.text("Kawasan:", 10, 59);
            docPDF.text(`${order.district || "-"}`, 30, 59);

            docPDF.text(`Status: ${order.status || "-"}`, 10, 66);
            docPDF.text(`Tarikh: ${order.orderDate?.toDate
                ? new Date(order.orderDate.toDate()).toLocaleString("ms-MY")
                : new Date(order.orderDate).toLocaleString("ms-MY")
                }`, 10, 73);
            docPDF.text(`No. Rujukan: ${order.orderNumber || order.id}`, 10, 80);

            let y = 95;
            docPDF.setFontSize(11);
            docPDF.text("Bil", 10, y);
            docPDF.text("Nama Barang & Butiran", 20, y);
            docPDF.text("Harga Seunit", 110, y);
            docPDF.text("Kuantiti", 140, y);
            docPDF.text("Jumlah (RM)", 170, y);
            y += 8;

            let bil = 1;
            let grandTotal = 0;

            const itemsData = (() => {
                if (Array.isArray(order.items)) {
                    return order.items.flatMap(item => {
                        if (item.hargaSnapshot) {
                            // PATCH: buku/runcit non-split
                            if (typeof item.hargaSnapshot.qty === "number") {
                                return [{
                                    name: item.name,
                                    variant: "",
                                    harga: item.hargaSnapshot.hargaJual
                                        ?? item.hargaSnapshot.hargaPengurus
                                        ?? item.hargaSnapshot.hargaPengerusi
                                        ?? item.hargaSnapshot.hargaKos
                                        ?? 0,
                                    qty: item.hargaSnapshot.qty,
                                }];
                            }
                            // baju/buku split
                            return Object.entries(item.hargaSnapshot).map(([variant, val]) => ({
                                name: item.name,
                                variant,
                                harga: val.hargaJual ?? val.hargaPengurus ?? val.hargaPengerusi ?? val.hargaKos ?? 0,
                                qty: val.qty ?? 0,
                            }));
                        } else if (item.quantity) {
                            // runcit, buku lama
                            return [{
                                name: item.name,
                                variant: "",
                                harga: item.price ?? 0,
                                qty: item.quantity ?? 0
                            }];
                        } else if (item.sizes) {
                            return Object.entries(item.sizes).map(([size, qty]) => ({
                                name: item.name,
                                variant: size,
                                harga: item.hargaPerSize?.[size] ?? item.price ?? 0,
                                qty
                            }));
                        } else if (item.years) {
                            return Object.entries(item.years).map(([year, qty]) => ({
                                name: item.name,
                                variant: year,
                                harga: item.hargaPerYear?.[year] ?? item.price ?? 0,
                                qty
                            }));
                        } else {
                            return [];
                        }
                    });
                }
                // ...bahagian lain kekal
                return [];
            })();




            for (const item of itemsData) {
                const harga = item.harga ?? 0;
                const qty = item.qty ?? item.quantity ?? 0;
                const jumlah = qty * harga;

                const wrappedName = docPDF.splitTextToSize(item.name, 80);


                docPDF.text(`${bil}`, 10, y);
                docPDF.text(wrappedName, 20, y);
                docPDF.text(`RM ${harga.toFixed(2)}`, 110, y);
                docPDF.text(`${qty} pcs`, 140, y);
                docPDF.text(`RM ${jumlah.toFixed(2)}`, 170, y);

                let varianLineOffset = 0;
                if (item.variant) {
                    docPDF.setFontSize(10);
                    docPDF.text(`${item.variant}`, 22, y + (wrappedName.length * 5));
                    docPDF.setFontSize(11);
                    varianLineOffset = 5;
                }

                y += 7 + ((wrappedName.length - 1) * 5) + varianLineOffset;

                if (y > 285) {
                    docPDF.addPage();
                    y = 20;
                }
                grandTotal += jumlah;
                bil++;
            }

            docPDF.setFontSize(12);
            docPDF.text(`Jumlah Bayaran Keseluruhan: RM ${grandTotal.toFixed(2)}`, 120, y + 10);
            docPDF.save(`Invois_${order.orderNumber || order.id}.pdf`);
        };

        logo.onerror = () => {
            alert("Gagal muatkan logo.");
        };
    };

    const calculateOrderTotal = (order) => {
        return order.items.reduce((total, item) => {
            if (item.hargaSnapshot) {
                // PATCH: buku/runcit non-split
                if (typeof item.hargaSnapshot.qty === "number") {
                    const harga = item.hargaSnapshot.hargaJual
                        ?? item.hargaSnapshot.hargaPengurus
                        ?? item.hargaSnapshot.hargaPengerusi
                        ?? item.hargaSnapshot.hargaKos
                        ?? 0;
                    return total + (item.hargaSnapshot.qty * harga);
                }
                // baju, buku split
                return total + Object.values(item.hargaSnapshot).reduce((sum, val) =>
                    sum + ((val.hargaJual ?? val.hargaPengurus ?? val.hargaPengerusi ?? val.hargaKos ?? 0) * (val.qty ?? 0)), 0
                );
            }
            // fallback untuk runcit, buku lama
            let itemTotal = 0;
            if (item.quantity) {
                itemTotal = (item.price ?? 0) * item.quantity;
            } else if (item.sizes) {
                itemTotal = Object.entries(item.sizes).reduce((sum, [size, qty]) =>
                    sum + ((item.hargaPerSize?.[size] ?? item.price ?? 0) * qty), 0
                );
            } else if (item.years) {
                itemTotal = Object.entries(item.years).reduce((sum, [year, qty]) =>
                    sum + ((item.hargaPerYear?.[year] ?? item.price ?? 0) * qty), 0
                );
            }
            return total + itemTotal;
        }, 0).toFixed(2);
    };

    // 🧩 Pulihkan stok berdasarkan order.items
    const restoreStockFromOrder = async (order) => {
        // Ambil semua stocks sekali dan buat map ikut "name"
        const snap = await getDocs(collection(db, "inventori", "selangor", "stocks"));
        const stockMap = new Map();
        snap.forEach((d) => stockMap.set(d.data().name, { id: d.id, data: d.data() }));

        // Helper: tambah nilai dengan selamat
        const safeAdd = (a, b) => (Number(a || 0) + Number(b || 0));

        // Loop item order
        for (const item of (order.items || [])) {
            const stockInfo = stockMap.get(item.name);
            if (!stockInfo) continue; // jika barang sudah tiada dalam master stok

            const stockRef = doc(db, "inventori", "selangor", "stocks", stockInfo.id);
            const stockSnap = await getDoc(stockRef);
            if (!stockSnap.exists()) continue;

            const stockData = stockSnap.data();
            const updated = {};

            // Kesan bentuk kuantiti dalam order
            // 1) Struktur baru: simpan di hargaSnapshot
            if (item.hargaSnapshot) {
                // (a) Non-split: qty terus
                if (typeof item.hargaSnapshot.qty === "number") {
                    if (typeof stockData.quantity === "number") {
                        updated.quantity = safeAdd(stockData.quantity, item.hargaSnapshot.qty);
                    }
                } else {
                    // (b) Split varian (saiz/tahun)
                    // Keputusan: ikut struktur master stok (sizeQuantities atau yearQuantities)
                    if (stockData.sizeQuantities && typeof stockData.sizeQuantities === "object") {
                        const newSizes = { ...stockData.sizeQuantities };
                        Object.entries(item.hargaSnapshot).forEach(([variant, val]) => {
                            const qty = Number(val?.qty || 0);
                            if (!qty) return;
                            newSizes[variant] = safeAdd(newSizes[variant], qty);
                        });
                        updated.sizeQuantities = newSizes;
                    } else if (stockData.yearQuantities && typeof stockData.yearQuantities === "object") {
                        const newYears = { ...stockData.yearQuantities };
                        Object.entries(item.hargaSnapshot).forEach(([variant, val]) => {
                            const qty = Number(val?.qty || 0);
                            if (!qty) return;
                            newYears[variant] = safeAdd(newYears[variant], qty);
                        });
                        updated.yearQuantities = newYears;
                    } else if (typeof stockData.quantity === "number") {
                        // fallback jika master hanya ada quantity
                        const totalQty = Object.values(item.hargaSnapshot).reduce((s, v) => s + Number(v?.qty || 0), 0);
                        updated.quantity = safeAdd(stockData.quantity, totalQty);
                    }
                }
            }
            // 2) Struktur lama: quantity / sizes / years
            else if (item.quantity) {
                if (typeof stockData.quantity === "number") {
                    updated.quantity = safeAdd(stockData.quantity, item.quantity);
                }
            } else if (item.sizes && stockData.sizeQuantities) {
                const newSizes = { ...stockData.sizeQuantities };
                Object.entries(item.sizes).forEach(([size, qty]) => {
                    newSizes[size] = safeAdd(newSizes[size], qty);
                });
                updated.sizeQuantities = newSizes;
            } else if (item.years && stockData.yearQuantities) {
                const newYears = { ...stockData.yearQuantities };
                Object.entries(item.years).forEach(([year, qty]) => {
                    newYears[year] = safeAdd(newYears[year], qty);
                });
                updated.yearQuantities = newYears;
            }

            if (Object.keys(updated).length) {
                await updateDoc(stockRef, updated);
            }
        }
    };

    // 🗑️ Padam order (hanya untuk pengurus, sebelum dihantar ke HQ)
    const handleDeleteOrder = async (order) => {
        // hadkan status yang boleh dipadam (belum dihantar ke HQ / belum disatukan)
        const deletableStatuses = [ORDER_STATUS.ORDER_CONFIRMED];
        if (!deletableStatuses.includes(order.status)) {
            alert("Order hanya boleh dipadam sebelum dihantar ke HQ.");
            return;
        }
        if (userRole !== "pengurus") {
            alert("Hanya pengurus boleh padam order sendiri sebelum dihantar ke HQ.");
            return;
        }

        const ok = window.confirm(`Padam order ${order.orderNumber || order.id}? Stok akan dipulihkan.`);
        if (!ok) return;

        try {
            // 1) Pulihkan stok
            await restoreStockFromOrder(order);

            // 2) Padam dokumen order
            const orderRef = doc(db, "inventori", "selangor", "orders", order.id);
            await deleteDoc(orderRef);

            alert("Order berjaya dipadam dan stok dipulihkan.");
        } catch (e) {
            console.error("Gagal padam order:", e);
            alert("Gagal memadam order. Sila cuba lagi.");
        }
    };



    const handleAddToCompiled = (order) => {
        if (selectedOrders.some(o => o.id === order.id)) return;
        const newList = [...selectedOrders, order];
        setSelectedOrders(newList);
    };

    const handleRemoveFromCompiled = (orderId) => {
        const newList = selectedOrders.filter(o => o.id !== orderId);
        setSelectedOrders(newList);
    };


    function summarizeCompiledOrders(orders, extras = {}) {
        const summary = {};

        orders.forEach((order) => {
            (order.items || []).forEach((item) => {
                const category = item.category || "Lain-lain";
                const itemName = item.name;

                if (!summary[category]) summary[category] = {};
                if (!summary[category][itemName]) summary[category][itemName] = {};

                // ✅ 1) Struktur baru: hargaSnapshot
                if (item.hargaSnapshot) {
                    // (a) Non-split: qty terus
                    if (typeof item.hargaSnapshot.qty === "number") {
                        const variant = "Jumlah";
                        const prevOrdered = summary[category][itemName][variant]?.ordered || 0;
                        const ordered = prevOrdered + Number(item.hargaSnapshot.qty || 0);
                        const extra = Number(extras[category]?.[itemName]?.[variant] || 0);

                        summary[category][itemName][variant] = {
                            ordered,
                            extra,
                            total: ordered + extra,
                        };
                        return;
                    }

                    // (b) Split: variant -> { qty }
                    Object.entries(item.hargaSnapshot).forEach(([variant, val]) => {
                        const prevOrdered = summary[category][itemName][variant]?.ordered || 0;
                        const ordered = prevOrdered + Number(val?.qty || 0);
                        const extra = Number(extras[category]?.[itemName]?.[variant] || 0);

                        summary[category][itemName][variant] = {
                            ordered,
                            extra,
                            total: ordered + extra,
                        };
                    });

                    return;
                }

                // ✅ 2) Struktur lama: quantity flat
                if (item.quantity) {
                    const variant = "Jumlah";
                    const prevOrdered = summary[category][itemName][variant]?.ordered || 0;
                    const ordered = prevOrdered + Number(item.quantity || 0);
                    const extra = Number(extras[category]?.[itemName]?.[variant] || 0);

                    summary[category][itemName][variant] = {
                        ordered,
                        extra,
                        total: ordered + extra,
                    };
                    return;
                }

                // ✅ 3) Struktur lama: ikut saiz
                if (item.sizes) {
                    Object.entries(item.sizes).forEach(([size, qty]) => {
                        const prevOrdered = summary[category][itemName][size]?.ordered || 0;
                        const ordered = prevOrdered + Number(qty || 0);
                        const extra = Number(extras[category]?.[itemName]?.[size] || 0);

                        summary[category][itemName][size] = {
                            ordered,
                            extra,
                            total: ordered + extra,
                        };
                    });
                    return;
                }

                // ✅ 4) Struktur lama: ikut tahun
                if (item.years) {
                    Object.entries(item.years).forEach(([year, qty]) => {
                        const prevOrdered = summary[category][itemName][year]?.ordered || 0;
                        const ordered = prevOrdered + Number(qty || 0);
                        const extra = Number(extras[category]?.[itemName]?.[year] || 0);

                        summary[category][itemName][year] = {
                            ordered,
                            extra,
                            total: ordered + extra,
                        };
                    });
                }
            });
        });

        return summary;
    }




    const sendCompiledOrderToPengarah = async () => {
        if (selectedOrders.length === 0) {
            alert("Tiada order dipilih untuk dihantar!");
            return;
        }

        try {
            const orderNumbers = selectedOrders.map(order => order.orderNumber);
            const summarizedItems = summarizeCompiledOrders(selectedOrders, extraQuantities);

            const compiledOrder = {
                orderNumber: await generateRefNumber("CM", userDistrict),

                district: userDistrict,
                pengerusiId: userId,
                pengerusiName: storedUser?.name || "Tidak Dikenalpasti",
                orders: orderNumbers,
                items: summarizedItems,
                status: ORDER_STATUS.ORDER_SENT_TO_HQ,
                orderDate: new Date()
            };

            await addDoc(collection(db, "inventori", "selangor", "compiledOrders"), compiledOrder);

            selectedOrders.forEach(async (order) => {
                const orderRef = doc(db, "inventori", "selangor", "orders", order.id);
                await updateDoc(orderRef, { status: ORDER_STATUS.ORDER_SENT_TO_HQ, });
            });

            alert("Order berjaya dihantar kepada pengarah!");
            setSelectedOrders([]);
            onPendingChange?.(false);


        } catch (error) {
            console.error("❌ Gagal menghantar order kepada pengarah:", error);
            alert("Gagal menghantar order. Sila cuba lagi.");
        }
    };

    const handleBranchDelivered = async (orderId) => {
        const confirmMsg = "Anda pasti ingin serahkan order ini kepada cawangan?";
        if (!window.confirm(confirmMsg)) return;

        try {
            const orderRef = doc(db, "inventori", "selangor", "orders", orderId);
            await updateDoc(orderRef, { status: ORDER_STATUS.BRANCH_DELIVERED });
            alert("✅ Status telah dikemaskini kepada 'Serah Cawangan'!");
        } catch (error) {
            console.error("❌ Gagal mengemas kini status:", error);
            alert("Gagal mengemaskini status. Sila cuba lagi.");
        }
    };


    const markAsCompleted = async (orderId) => {
        let confirmMsg = "Anda pasti nak tukar status order ini kepada 'Selesai'?";
        if (userRole === "pengurus") {
            confirmMsg = "Saya mengaku telah menerima barangan pembekalan ini dan bersetuju status ditandakan sebagai 'Selesai'.";
        }
        if (!window.confirm(confirmMsg)) return;

        try {
            const orderRef = doc(db, "inventori", "selangor", "orders", orderId);
            await updateDoc(orderRef, { status: ORDER_STATUS.ORDER_COMPLETED });
            alert("✅ Status telah dikemaskini kepada 'Selesai'!");
        } catch (error) {
            console.error("❌ Gagal mengemas kini status:", error);
            alert("Gagal mengemaskini status. Sila cuba lagi.");
        }
    };


    const handleExtraChange = (category, itemName, variant, value) => {
        setExtraQuantities(prev => ({
            ...prev,
            [category]: {
                ...prev[category],
                [itemName]: {
                    ...((prev[category] && prev[category][itemName]) || {}),
                    [variant]: parseInt(value) || 0
                }
            }
        }));
    };



    return (
        <div className="order-list-container">
            <h2>Senarai Tempahan</h2>
            <table className="order-table">
                <thead>
                    <tr>
                        <th>Tarikh</th>

                        <th>No. Order</th>
                        <th>Nama Barang & Kuantiti</th>
                        {userRole === "pengerusi" && <th>Cawangan</th>}
                        <th>Jumlah</th>
                        <th>Status</th>
                        <th>Tindakan</th>
                    </tr>
                </thead>
                <tbody>
                    {orders
                        .slice() // supaya tak mutate asal
                        .sort((a, b) => {
                            const ta = a.orderDate?.toDate ? a.orderDate.toDate() : new Date(a.orderDate);
                            const tb = b.orderDate?.toDate ? b.orderDate.toDate() : new Date(b.orderDate);
                            return tb - ta; // Descending (baru dulu)
                        })
                        .map((order) => (
                            <tr key={order.id}>
                                <td data-label="Tarikh">
                                    {order.orderDate
                                        ? (order.orderDate.toDate ? order.orderDate.toDate().toLocaleString("ms-MY") : new Date(order.orderDate).toLocaleString("ms-MY"))
                                        : "N/A"}
                                </td>

                                <td data-label="No. Order">{order.orderNumber || "N/A"}</td>

                                <td data-label="Nama Barang & Kuantiti">
                                    {(() => {
                                        const isOpen = openRowId === order.id;
                                        const summary = getOrderItemsSummary(order);

                                        return (
                                            <div>
                                                {/* ✅ Ringkas + Butang Lihat */}
                                                <div className="items-summary-row">
                                                    <span>
                                                        📦 {summary.products} barang • {summary.totalUnits} unit
                                                    </span>

                                                    <button
                                                        className="items-toggle-btn"
                                                        type="button"
                                                        onClick={() => toggleRow(order.id)}
                                                    >
                                                        {isOpen ? "Tutup" : "Lihat"}
                                                    </button>
                                                </div>

                                                {/* ✅ Accordion */}
                                                {isOpen && (
                                                    <div className="items-accordion">
                                                        {Array.isArray(order.items) && order.items.length > 0 ? (
                                                            order.items.map((item, i) => (
                                                                <div key={i} className="items-li">
                                                                    <span className="items-product">{item.name}</span>{" "}
                                                                    <span className="items-qty">
                                                                        —{" "}
                                                                        {item.hargaSnapshot ? (
                                                                            Array.isArray(item.hargaSnapshot) ? (
                                                                                "Ralat data harga"
                                                                            ) : typeof item.hargaSnapshot.qty === "number" ? (
                                                                                // buku/runcit non-split
                                                                                <>
                                                                                    {item.hargaSnapshot.qty} pcs (RM
                                                                                    {(item.hargaSnapshot.hargaJual ??
                                                                                        item.hargaSnapshot.hargaPengurus ??
                                                                                        item.hargaSnapshot.hargaPengerusi ??
                                                                                        item.hargaSnapshot.hargaKos ??
                                                                                        0
                                                                                    ).toFixed(2)}
                                                                                    )
                                                                                </>
                                                                            ) : (
                                                                                // baju/buku split
                                                                                Object.entries(item.hargaSnapshot).map(([variant, val]) => (
                                                                                    <div key={variant}>
                                                                                        {variant}: {val.qty} pcs (RM
                                                                                        {(
                                                                                            val.hargaJual ??
                                                                                            val.hargaPengurus ??
                                                                                            val.hargaPengerusi ??
                                                                                            val.hargaKos ??
                                                                                            0
                                                                                        ).toFixed(2)}
                                                                                        )
                                                                                    </div>
                                                                                ))
                                                                            )
                                                                        ) : item.quantity ? (
                                                                            `${item.quantity} pcs (RM${(item.price ?? 0).toFixed(2)})`
                                                                        ) : item.sizes ? (
                                                                            Object.entries(item.sizes).map(([size, qty]) => (
                                                                                <div key={size}>
                                                                                    {size}: {qty} pcs (RM
                                                                                    {(
                                                                                        item.hargaPerSize?.[size] ??
                                                                                        item.price ??
                                                                                        0
                                                                                    ).toFixed(2)}
                                                                                    )
                                                                                </div>
                                                                            ))
                                                                        ) : item.years ? (
                                                                            Object.entries(item.years).map(([year, qty]) => (
                                                                                <div key={year}>
                                                                                    {year}: {qty} pcs (RM
                                                                                    {(
                                                                                        item.hargaPerYear?.[year] ??
                                                                                        item.price ??
                                                                                        0
                                                                                    ).toFixed(2)}
                                                                                    )
                                                                                </div>
                                                                            ))
                                                                        ) : (
                                                                            "-"
                                                                        )}
                                                                    </span>
                                                                </div>
                                                            ))
                                                        ) : (
                                                            <div className="items-li">Tiada Item</div>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })()}
                                </td>




                                {userRole === "pengerusi" && (
                                    <td data-label="Cawangan">{order.branchName || "Tidak Diketahui"}</td>
                                )}

                                <td data-label="Jumlah">RM {calculateOrderTotal(order)}</td>
                                <td data-label="Status">{order.status}</td>

                                <td data-label="Tindakan">
                                    <button className="invoice-button" onClick={() => downloadInvoice(order)}>
                                        Invois
                                    </button>

                                    {userRole === "pengerusi" && order.status === ORDER_STATUS.ORDER_CONFIRMED && (
                                        <button
                                            className="compile-button"
                                            onClick={() => handleAddToCompiled(order)}
                                            disabled={selectedOrders.some(o => o.id === order.id)}
                                            style={{ marginLeft: "5px" }}
                                        >
                                            {selectedOrders.some(o => o.id === order.id) ? "✔ Ditambah" : "Tambah"}
                                        </button>
                                    )}


                                    {userRole === "pengerusi" && order.status === ORDER_STATUS.HQ_DELIVERED && (
                                        <button
                                            className="deliver-button"
                                            onClick={() => handleBranchDelivered(order.id)}
                                            style={{ marginLeft: "5px", backgroundColor: "green", color: "white" }}
                                        >
                                            Serah Cawangan
                                        </button>
                                    )}

                                    {userRole === "pengurus" && order.status === ORDER_STATUS.BRANCH_DELIVERED && (
                                        <button
                                            className="done-button"
                                            onClick={() => markAsCompleted(order.id)}
                                            style={{ marginLeft: "5px", backgroundColor: "blue", color: "white" }}
                                        >
                                            Selesai
                                        </button>
                                    )}

                                    {userRole === "pengurus" && order.status === ORDER_STATUS.ORDER_CONFIRMED && (
                                        <button
                                            className="delete-button"
                                            onClick={() => handleDeleteOrder(order)}
                                            style={{ marginLeft: "5px", backgroundColor: "#c62828", color: "#fff" }}
                                        >
                                            Padam
                                        </button>
                                    )}

                                </td>
                            </tr>

                        ))}
                </tbody>
            </table>

            <div className="status-reference">
                <h3>📌 Nota Status :</h3>
                <ul>
                    <li><strong>Hantar Kawasan</strong>: Tempahan sedang disemak oleh pengerusi kawasan.</li>
                    <li><strong>Serah Kawasan</strong>: Tempahan sudah sampai di kawasan, sila berhubung dengan pengerusi kawasan.</li>
                    <li><strong>Hantar Negeri</strong>: Tempahan sudah diterima di peringkat negeri</li>
                    <li><strong>Serah Cawangan</strong>: Pengerusi telah menyerahkan barang kepada pengurus cawangan.</li>
                    <li><strong>Selesai</strong>: Pengurus mengesahkan telah menerima barang.</li>
                </ul>
            </div>



            {userRole === "pengerusi" && selectedOrders.length > 0 && (
                <div className="compiled-section">
                    <h3>Senarai Order Terpilih untuk Dihantar</h3>
                    <ul>
                        {selectedOrders.map((order) => (
                            <li key={order.id} style={{ display: "flex", alignItems: "center" }}>
                                <span>{order.orderNumber}</span>
                                <button
                                    onClick={() => handleRemoveFromCompiled(order.id)}
                                    style={{ marginLeft: "10px", color: "red" }}
                                >
                                    ❌ Buang
                                </button>
                            </li>
                        ))}
                    </ul>

                    <h3>Ringkasan Tempahan</h3>
                    {Object.entries(summarizeCompiledOrders(selectedOrders, extraQuantities)).map(([category, items]) => (
                        <div key={category} style={{ marginBottom: 24 }}>
                            <strong style={{ textTransform: "capitalize" }}>{category}</strong>
                            {Object.entries(items).map(([itemName, variants]) => (
                                <div key={itemName} style={{ marginLeft: 12, marginBottom: 10 }}>
                                    <span style={{ fontWeight: 500 }}>{itemName}</span>
                                    <div style={{
                                        display: "flex",
                                        flexWrap: "wrap",
                                        gap: "10px 32px",
                                        marginTop: 4,
                                        alignItems: "center"
                                    }}>
                                        {Object.entries(variants).map(([variant, valueObj]) => (
                                            <div
                                                key={variant}
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    minWidth: 200,
                                                    marginBottom: 4,
                                                    borderBottom: "1px solid #eee",
                                                    paddingBottom: 2
                                                }}>
                                                <span style={{ minWidth: 48, fontWeight: 400 }}>{variant}:</span>
                                                <span style={{ minWidth: 40, fontWeight: 600 }}>{valueObj.ordered} unit</span>
                                                <input
                                                    type="number"
                                                    min="0"
                                                    value={extraQuantities[category]?.[itemName]?.[variant] || ""}
                                                    onChange={e =>
                                                        handleExtraChange(
                                                            category,
                                                            itemName,
                                                            variant,
                                                            e.target.value
                                                        )
                                                    }
                                                    style={{
                                                        width: 48,
                                                        margin: "0 6px",
                                                        border: "1px solid #ccc",
                                                        borderRadius: 4,
                                                        fontSize: 14
                                                    }}
                                                    placeholder="Extra"
                                                />
                                                <span style={{ color: "#1e88e5", fontWeight: 600, minWidth: 90 }}>
                                                    Jumlah: {valueObj.total} unit
                                                </span>
                                                {valueObj.extra > 0 &&
                                                    <span style={{ color: "#ff9800", fontWeight: 500, marginLeft: 4 }}>
                                                        (+{valueObj.extra} extra)
                                                    </span>}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    ))}




                    <button className="submit-button" onClick={sendCompiledOrderToPengarah}>Hantar Order kepada Pengarah</button>
                </div>
            )}
        </div>
    );
};

export default OrderList;